import { ServicesConfig } from '@nab/x-types';

export const getInteractionPrefixConfig = (interactionPrefix): Partial<ServicesConfig> => {
	return {
		interactionPrefix: interactionPrefix
	};
};
